import { m } from "../paraglide/messages.js";
import { isDark, preferences } from "../preferences";
import { togglePin, toggleRail } from "./sidebar-state";

// The commands offered from more than one place (the user menu, ⌘K, the sidebar), with one label and one effect.

export const themeCommand = () => ({
  label: isDark() ? m.theme_switch_light() : m.theme_switch_dark(),
  run: () => preferences.setTheme(isDark() ? "light" : "dark"),
});

/** The column of icons and back (ADR-114); only where the sidebar is a column. */
export const railCommand = (rail: boolean) => ({ label: rail ? m.nav_expand() : m.nav_collapse(), run: toggleRail });

/** A place or a home queue on the sidebar and off, by its key (`placeKey`, `queueKey`). */
export const pinCommand = (key: string, name: string, pinned: boolean) => ({
  label: (pinned ? m.unpin_from_sidebar : m.pin_to_sidebar)({ name }),
  run: () => togglePin(key),
});
